import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class SpreaderAPI extends ComponentAPI {
    /**
     * Returns the data used to select the spreaded entries.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Updates the data that is used to spread the informed entries.
     *
     * @param data - The updated data.
     */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Returns the entries that should be spreaded.
     */
    getEntries() {
        return this.state.entries;
    }
    /**
     * Updates the entries used to spread the data.
     *
     * @param entries - The updated entries.
     */
    setEntries(entries) {
        this.setState({ entries });
    }
}
export { SpreaderAPI, };
//# sourceMappingURL=spreader-api.js.map